import React from "react";
import { Provider } from "mobx-react";
import { Toaster } from "react-hot-toast";
import { PlausibleProvider } from "./Contexts/PlausibleContext.js";

import Routes from "./Routes";
import NotificationPromptModal from "./Components/NotificationPromptModal";
import PlaylistStore from "./Stores/PlaylistStore";
import RecentUsersStore from "./Stores/RecentUsersStore";
import MyProfileStore from "./Stores/MyProfileStore";
import UserProfileStore from "./Stores/UserProfileStore";
import PlaybackStore from "./Stores/PlaybackStore";
import AdminStore from "./Stores/AdminStore";
import DjStore from "./Stores/DjStore";

function App() {
  return (
    <PlausibleProvider>
      <Provider
        PlaylistStore={PlaylistStore}
        RecentUsersStore={RecentUsersStore}
        MyProfileStore={MyProfileStore}
        PlaybackStore={PlaybackStore}
        UserProfileStore={UserProfileStore}
        AdminStore={AdminStore}
        DjStore={DjStore}
      >
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            className: '',
            style: {
              background: '#171717',
              color: '#ffffff',
              border: '1px solid #262626',
              borderRadius: '6px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
            },
            success: {
              style: {
                background: '#171717',
                color: '#ffffff',
                border: '1px solid #10b981',
              },
              iconTheme: {
                primary: '#10b981',
                secondary: '#0a0a0a',
              },
            },
            error: {
              style: {
                background: '#171717',
                color: '#ffffff',
                border: '1px solid #ef4444',
              },
              iconTheme: {
                primary: '#ef4444',
                secondary: '#0a0a0a',
              },
            },
            loading: {
              style: {
                background: '#171717',
                color: '#ffffff',
                border: '1px solid #3b82f6',
              },
              iconTheme: {
                primary: '#3b82f6',
                secondary: '#0a0a0a',
              },
            },
          }}
        />
        <Routes />
        <NotificationPromptModal />
      </Provider>
    </PlausibleProvider>
  );
}

export default App;
